import React from 'react';
import { useSelector } from 'react-redux';
import { ProductCarousel } from '@noths/polaris-client-ribbons-design-system';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { useListingsRecommendations } from './useListingsRecommendations';

export interface RecommendedProductsCarouselContainerProps {
  readonly enableFreeDomesticDeliveryLabels?: boolean;
  readonly hideLabelIcons?: boolean;
  readonly placementType: 'item_page.same_seller2';
  title: string;
}

export const RecommendedProductsCarouselContainer = ({
  enableFreeDomesticDeliveryLabels,
  hideLabelIcons,
  placementType,
  title,
}: RecommendedProductsCarouselContainerProps) => {
  const state = useSelector((state: ReduxApplicationState) => state);
  const { currencyCode, gaVisitorId: visitorId } = state.user;
  const partnerShortCode = state.content.partner?.shortcode || '';

  const { recommendedProducts } = useListingsRecommendations({
    currencyCode,
    partnerShortCode,
    productCode: '123', // TODO: we don't have a product code to use
    placementType,
    servingConfig: 'pdp_same_seller_2',
    visitorId,
  });

  return recommendedProducts === null || recommendedProducts.length > 0 ? (
    <ProductCarousel
      currency={currencyCode}
      enableFreeDomesticDeliveryLabels={enableFreeDomesticDeliveryLabels}
      hideLabelIcons={hideLabelIcons}
      lazyImages
      products={recommendedProducts}
      title={title}
      titleAlignment="left"
    />
  ) : null;
};
